// removed by extract-text-webpack-plugin
module.exports = {"overlay-wd-small":"overlay-wd-small__2vu65","overlay-wd-medium":"overlay-wd-medium__1Xb84","overlay-wd-large":"overlay-wd-large__3ckdZ","cardContainerWrapper":"cardContainerWrapper__3NgGu","cardContainer":"cardContainer__1OKub","overlayBackdrop":"overlayBackdrop__j7EHw","overlayContainer":"overlayContainer__sk0ym","closeButtonContainer":"closeButtonContainer__3yqyD","closeIcon":"closeIcon__3Emb9","modelSlideIn":"modelSlideIn__gGCQG","slideInModalMobile":"slideInModalMobile__1PPl2","slideInModal":"slideInModal__1cY3w"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/buyWithInstacredLanding/overlayScreen/style.css
// module id = 5NY+
// module chunks = 323 328 331 357